import { durableStorage } from './durable';
import { memoryStorage } from './memory';
import { temporaryStorage } from './temporary';

export const appStorage = {
  memory: memoryStorage,

  session: temporaryStorage,

  durable: durableStorage,
} as const;

export type AppStorageType = keyof typeof appStorage;
